import { CreateProjectAPIRequest, CreateProjectAPIResponse } from 'src/researcher/types/project';
import { useRouter } from 'next/router';
import { createProjectAPI } from 'src/researcher/handlers/api';
import { ErrorCreatingProjectMsg } from 'src/researcher/constants/message.constants';
import { openToastr } from 'src/_common/handlers/services';
import { resetOverlayContainer } from 'src/researcher//handlers/grammar-check';
import { useCallback } from 'react';
import { useResetProject } from './useResetProject';
// import QuillEditor, { QuillEditorIDS } from '@Common/handlers/quillEditor';
// import { openToastr } from '@Common/handlers/services';
// import { useLocalStorageState } from '@Common/hooks';
// import { useRouter } from 'next/router';
// import { useDispatch } from 'react-redux';
// import { removeAllCitaionList } from 'src/citation-generator/reducers/actionCreators';
// import {
//   closeDialogAction,
//   launchDialogAction,
//   useDialogDispatch,
// } from 'src/researcher/context/ui/dialog';
// import { CreateProjectAPIResponse, ProjectStatusEnum } from 'src/researcher/types/project';
// import { KEYS, DEFAULT_EDITOR_HTML } from 'src/researcher/constants/common.constants';
// import { ErrorCreatingProjectMsg } from 'src/researcher/constants/message.constants';
// import {
//   useApplicationDispatch,
//   setTotalStorageUsedAction,
// } from 'src/researcher/context/application';
// import {
//   useBookmarkDispatch,
//   restoreAllBookmarkDataAction,
// } from 'src/researcher/context/bookmarks';
// import {
//   useProjectDispatch,
//   createdProjectAction,
//   setProjectStatusAction,
// } from 'src/researcher/context/project';
// import { ActiveDialogOnPageEnum } from 'src/researcher/context/ui/dialog.types';
// import { createProjectAPI } from 'src/researcher/handlers/api';
// import { EditorExecCommands } from 'src/researcher/models/IBaseEditorTypes';
// import { removeNonRestorableKeysFromLS } from 'src/researcher/utils';
// import { usePortalDispatch, closePortalAction } from 'src/researcher/context/ui/portal';
// import { setAppLayout } from '@Common/actions/commonActions';

// export function useCreateProject(handlers?: {
//   onThen?: (response: CreateProjectAPIResponse) => unknown;
//   onCatch?: (error: Error) => unknown;
// }) {
//   const dialogDispatch = useDialogDispatch();
//   const projectDispatch = useProjectDispatch();
//   const bookmarkDispatch = useBookmarkDispatch();
//   const applicationDispatch = useApplicationDispatch();
//   const portalDispatch = usePortalDispatch();
//   const dispatch = useDispatch();
//   const router = useRouter();
//   // eslint-disable-next-line @typescript-eslint/naming-convention
//   const [_, setHasProjectCreationFailed] = useLocalStorageState(
//     KEYS.LOCALSTORAGE_PROJECT_CREATION_FAILED,
//     false
//   );

//   const exec = (title: string, html: string) => {
//     let onThen = handlers?.onThen;
//     let onCatch = handlers?.onCatch;

//     // defaultHandler initialization
//     if (!onThen) {
//       // default then handler
//       const defaultOnThen = (project: CreateProjectAPIResponse) => {
//         // route and clear non essential keys
//         router.replace(`/co-writer?project=${project.id}`);
//         removeNonRestorableKeysFromLS();
//         dispatch(setAppLayout(true));

//         // setup research editor
//         localStorage.setItem(KEYS.LOCALSTORAGE_HTML, html);
//         QuillEditor.getInstance(QuillEditorIDS.RESEARCH_EDITOR)?.clearEditor();
//         QuillEditor.getInstance(QuillEditorIDS.RESEARCH_EDITOR)?.disable();
//         QuillEditor.getInstance(QuillEditorIDS.RESEARCH_EDITOR)?.enable();
//         QuillEditor.getInstance(QuillEditorIDS.RESEARCH_EDITOR)?.focusEditor();
//         QuillEditor.getInstance(QuillEditorIDS.RESEARCH_EDITOR)?.execCommand(
//           EditorExecCommands.MCEINSERTCONTENT,
//           false,
//           html
//         );
//         // setup scratchpad
//         localStorage.setItem(KEYS.LOCALSTORAGE_SCRATCHPAD, DEFAULT_EDITOR_HTML);
//         QuillEditor.getInstance(QuillEditorIDS.RESEARCH_SCRATCHPAD)?.setContent('');
//         // ! ORDER OF EXECUTION MATTER
//         portalDispatch(closePortalAction());
//         applicationDispatch(setTotalStorageUsedAction(project.totalStorageUsed));
//         projectDispatch(createdProjectAction(project));
//         bookmarkDispatch(restoreAllBookmarkDataAction([]));
//         dispatch(removeAllCitaionList());
//         dialogDispatch(closeDialogAction());
//         setHasProjectCreationFailed(false);
//       };
//       onThen = defaultOnThen;
//     }
//     if (!onCatch) {
//       const defaultOnCatch = () => {
//         openToastr(ErrorCreatingProjectMsg);
//         projectDispatch(setProjectStatusAction(ProjectStatusEnum.IDLE));
//         dialogDispatch(launchDialogAction(ActiveDialogOnPageEnum.OPEN_PROJECTS_DIALOG));
//         setHasProjectCreationFailed(true);
//         dispatch(setAppLayout(false));
//       };
//       onCatch = defaultOnCatch;
//     }
//     dialogDispatch(launchDialogAction(ActiveDialogOnPageEnum.CREATING_DIALOG));
//     return createProjectAPI({ title, html }).then(onThen).catch(onCatch);
//   };
//   return exec;
// }

/**

It is useful if promise need to be done in succession even after things are handled(catch);
It is like we listen to event 'catch' and 'data' many block may be attached independently

// this should wrap our api's
function modifyAPI<IRequest, IResponse>(api: (request: IRequest) => Promise<IResponse>) {
  return (request: IRequest) =>
    new Promise((resolve) =>
      api(request)
        .then((data) => resolve({ error: null, data }))
        .catch((error) => resolve({ error, data: null }))
    );
}
function pass(fn) {
  return (res) => {
    fn(res);
    return res;
  };
}

  const createAPI = () => http();
  const modCreateAPI = modifyAPI(createAPI);

  const onThen = (res) => {
    if (res.data) {
      // api succeeded do something
    }
  }

  const onCatch = (res) => {
    if (res.error) {
      // api failed do something else
    }
  }

  modCreateAPI({ title: 'abcd' })
    .then(pass(onThen))
    .then(pass(onCatch))

 */

export type UseCreateProjectOptions = {
  onThen: (value: CreateProjectAPIResponse) => void;
  onCatch: (err: Error) => void;
  execFinally?: (newProjectId: string) => Promise<unknown>;
};

function useCreateProject(props: UseCreateProjectOptions) {
  const exec = useCallback(
    ({ title = 'Untitled project', html = '', template = '' }: CreateProjectAPIRequest) =>
      createProjectAPI({ title, html, template })
        .then((res) => {
          props.onThen(res);
          props.execFinally?.(res.id);
        })
        .catch(props.onCatch),

    []
  );
  return exec;
}

export function useCreateProjectAndRoute(
  props?: Pick<UseCreateProjectOptions, 'onCatch' | 'execFinally'>
) {
  const router = useRouter();

  const onCatch =
    props?.onCatch ||
    (() => {
      openToastr(ErrorCreatingProjectMsg);
    });

  const execFinally = props?.execFinally || undefined;

  return useCreateProject({
    onCatch,
    onThen: (createdProject: CreateProjectAPIResponse) => {
      router.push(`/co-writer/home?project=${createdProject.id}`);
      /**  ! remove all previous project's gc errors */
      resetOverlayContainer();
    },
    execFinally,
  });
}
